import { Box, Typography, useTheme } from "@mui/material";
import { TEXT } from "@/features/reassistRequests/utils/tokens";
import { mapOverlaySx, salePinStyle } from "../utils/saleTokens";

interface Props {
  labels: { unpurchased: string; purchased: string };
  /** 読み上げ用の見出し（role="group" の aria-label）。見せない。 */
  heading?: string;
}

const SAMPLE_SIZE = 16;

/** 地図の幅がこれ未満のときは見出しを外し、見本だけにする（SP の地図は画面幅いっぱい）。 */
const NARROW = "@media (max-width: 359.95px)";

/** 凡例の見出し（ロゴは置かない。小さな地図の上で、ロゴの文字が大きく見えてしまうため）。 */
const LEGEND_TITLE = "役所資料（黒塗り）";

/**
 * 地図の左下に置く凡例。1段目に見出し（12px の文字）、2段目にピンと同じ定義から作った見本とラベル。
 */
export const SaleMapLegend: React.FC<Props> = ({ labels, heading }) => {
  const theme = useTheme();
  const items = [
    { key: "unpurchased", label: labels.unpurchased, purchased: false },
    { key: "purchased", label: labels.purchased, purchased: true },
  ];
  return (
    <Box
      role="group"
      aria-label={heading}
      sx={{
        ...mapOverlaySx(theme),
        left: theme.spacing(1),
        bottom: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1,
        pointerEvents: "none",
      }}
    >
      <Typography
        component="span"
        aria-hidden
        sx={{
          ...TEXT.label,
          fontWeight: 700,
          color: "text.secondary",
          [NARROW]: { display: "none" },
        }}
      >
        {LEGEND_TITLE}
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        {items.map((item) => {
          const style = salePinStyle(theme, item.purchased);
          const r = SAMPLE_SIZE / 2 - style.weight;
          return (
            <Box
              key={item.key}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              <svg
                width={SAMPLE_SIZE}
                height={SAMPLE_SIZE}
                viewBox={`0 0 ${SAMPLE_SIZE} ${SAMPLE_SIZE}`}
                aria-hidden
              >
                <circle
                  cx={SAMPLE_SIZE / 2}
                  cy={SAMPLE_SIZE / 2}
                  r={r}
                  fill={style.fillColor}
                  fillOpacity={style.fillOpacity}
                  stroke={style.fillColor}
                  strokeWidth={style.weight}
                />
              </svg>
              <Typography
                component="span"
                sx={{
                  ...TEXT.label,
                  color: "text.primary",
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
